import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="share"
export default class extends Controller {
  static values = {
    title: String,
    text: String,
    url: String
  }
  connect() {
    console.log("Connected");
  }

  async shareOrCopy(event) {
    const shareData = {
      title: this.titleValue,
      text: this.textValue,
      url: this.urlValue,
    }

    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        await navigator.clipboard.writeText(`${this.textValue} ${this.urlValue}`)
        this.element.innerText = "Copied to clipboard!";
      }
    } catch (err) {
      console.log(err);
    }
  }
}
